import { ref } from 'vue';

// The newsletter signup, shared by SubscribeForm and NewsletterSubscription:
// check the address, post it to the Buttondown list, and report back in a
// status line. `messages` overrides any of the three lines it shows.
export const BUTTONDOWN_ENDPOINT = 'https://buttondown.com/api/emails/embed-subscribe/jacquesramphal';

export const SUBSCRIBE_MESSAGES = {
  invalid: 'Please enter a valid email address.',
  success: 'Almost there — check your inbox to confirm.',
  error: 'Something went wrong. Please try again.',
};

const isValidEmail = (value) => /\S+@\S+\.\S+/.test(value);

export function useSubscribe({ endpoint = BUTTONDOWN_ENDPOINT, messages = {} } = {}) {
  const email = ref('');
  const message = ref('');
  const isSuccess = ref(false);
  const submitting = ref(false);
  const text = (key) => messages[key] || SUBSCRIBE_MESSAGES[key];

  const subscribe = async () => {
    const value = email.value.trim();

    if (!isValidEmail(value)) {
      isSuccess.value = false;
      message.value = text('invalid');
      return;
    }

    submitting.value = true;
    message.value = '';

    try {
      await fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: value }),
      });
      // A no-cors request returns an opaque response, so the status can't be
      // read. Buttondown sends its own confirmation email; treat the submit as
      // delivered and point the reader there.
      isSuccess.value = true;
      message.value = text('success');
      email.value = '';
    } catch (e) {
      isSuccess.value = false;
      message.value = text('error');
    } finally {
      submitting.value = false;
    }
  };

  return { email, message, isSuccess, submitting, subscribe };
}
